import { useQuery, gql } from "@apollo/client"
import { ARTIST_ADDRESSES } from "config"

const artistAddressFilter = ARTIST_ADDRESSES.map((address) => `"${address.toLowerCase()}"`).join(", ")

const countProjectsQuery = () => `
  query GetProjects {
    projects(
        where: {
          artistAddress_in: [${artistAddressFilter}]
          active: true
        }
    ) {
      id
    }
  }`
const useCountProjects = () => {
  const { loading, error, data } = useQuery(gql(countProjectsQuery()))

  return {
    loading,
    error,
    data
  }
}

export default useCountProjects
